module.exports = __webpack_public_path__ + "media/pouches/pouch_with_sparks--yellow-c3729183.svg";